<!--Form Register-->
<mdb-card class="animated card-login position-absolute"
          style="top: -50%;left: 0;width: 100%;"
          [class.d-none]="formType !== 'register'" [class.flipInY]="formType === 'register'">
  <mdb-card-body >
    <!--Header-->
    <div class="text-center">
      <h3 class="white-text">Solicitar registro</h3>
      <hr class="hr-light">
    </div>
    <!--Body-->
    <form [formGroup]="registerForm">

      <div class="md-form">
        <mdb-icon fas icon="user" class="prefix white-text active"></mdb-icon>
        <input type="text" formControlName="name" class="text-white form-control" mdbInput>
        <label class="text-white">Nombre</label>
        <mdb-error *ngIf="registerHasError('name', 'required'); else error_name_2">El nombre es un campo requerido</mdb-error>
        <ng-template #error_name_2>
          <mdb-error *ngIf="registerHasError('name', 'minlength')">Nombre muy corto.</mdb-error>
        </ng-template>
      </div>

      <div class="md-form">
        <mdb-icon fas icon="envelope" class="prefix white-text active"></mdb-icon>
        <input type="email" formControlName="email" class="text-white form-control" mdbInput>
        <label class="text-white">Correo electrónico</label>
        <mdb-error *ngIf="registerHasError('email', 'required'); else error_email_2">Se requiere un correo electrónico</mdb-error>
        <ng-template #error_email_2>
          <mdb-error *ngIf="registerHasError('email', 'email')">Formato de correo electrónico incorreto.</mdb-error>
        </ng-template>
      </div>

      <div class="md-form">
        <mdb-icon fas icon="lock" class="prefix text-white active"></mdb-icon>
        <input type="password" formControlName="plainPassword" class="text-white form-control" mdbInput>
        <label class="text-white">Contraseña</label>
        <mdb-error *ngIf="registerHasError('plainPassword', 'required'); else error_password_2">Debe ingresar su contraseña.</mdb-error>
        <ng-template #error_password_2>
          <mdb-error *ngIf="registerHasError('plainPassword', 'minlength')">Longitud de la contraseña muy corta.</mdb-error>
        </ng-template>
      </div>

      <div class="md-form">
        <mdb-icon fas icon="lock" class="prefix text-white active"></mdb-icon>
        <input type="password" formControlName="confirmPassword" class="text-white form-control" mdbInput>
        <label class="text-white">Confirmar contraseña</label>
        <mdb-error *ngIf="registerHasError('confirmPassword', 'required'); else error_password_4">Este campo es requerido.</mdb-error>
        <ng-template #error_password_4>
          <mdb-error *ngIf="registerHasError('confirmPassword', 'sameValue')">Las contraseñas no coinciden.</mdb-error>
        </ng-template>
      </div>

    </form>

    <div class="text-center mt-4">
      <button mdbBtn color="indigo" mdbWavesEffect
              (click)="register()">Solicitar</button>
      <hr class="hr-light mb-3 mt-4">
      <div class="inline-ul text-center d-flex justify-content-center">
        <a class="btn btn-link text-white-50" href="javascript:void(0)"
           (click)="onGoToLogin.emit()">
          Ya soy usuario
        </a>
      </div>
    </div>
  </mdb-card-body>
</mdb-card>
<!--/.Form-->
